import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuaDetailPage from "../pages/gua/detail/page";
import ZhinanDetailPage from "../pages/zhinan/detail/page";
import FaqPage from "../pages/faq/page";
import AboutPage from "../pages/about/page";
import PageShell from "../components/feature/PageShell";

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <PageShell>
        <Home />
      </PageShell>
    ),
  },
  {
    path: "/gua/:id",
    element: (
      <PageShell>
        <GuaDetailPage />
      </PageShell>
    ),
  },
  {
    path: "/zhinan/:id",
    element: (
      <PageShell>
        <ZhinanDetailPage />
      </PageShell>
    ),
  },
  {
    path: "/faq",
    element: (
      <PageShell>
        <FaqPage />
      </PageShell>
    ),
  },
  {
    path: "/about",
    element: (
      <PageShell>
        <AboutPage />
      </PageShell>
    ),
  },
  {
    path: "*",
    element: (
      <PageShell>
        <NotFound />
      </PageShell>
    ),
  },
];

export default routes;